import {actions} from './actions'
import {getters} from './getters'
import {mutations} from './mutations'

const state = {
    loading: false,
    pageTitle: false,
    closeSidebar: false,
    breadcrumb: [],
    nazioni: [],
    provincie: [],
    citta: [],
};

export default {
    state,
    actions,
    getters,
    mutations
}
